import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";
import { localStorageUtil } from "../../utils/localStorageUtil";

// SECTION: AUTH THUNKS

// NOTE: User SignIn
export const signin = createAsyncThunk("auth/signin/user", async (data) => {
  const consentId = localStorageUtil.get('consentId');
  const requestData = consentId ? { ...data, consentId } : data;
  const response = await api.post("auth/signin/user", requestData);
  
  // Clear consentId after successful authentication
  if (response.data?.data?.token) {
    localStorageUtil.remove('consentId');
  }
  
  return response.data;
});

// NOTE: User Signup
export const signup = createAsyncThunk("auth/signup/user", async (data) => {
  const consentId = localStorageUtil.get('consentId');
  const requestData = consentId ? { ...data, consentId } : data;
  const response = await api.post("auth/signup/user", requestData);
  
  // Clear consentId after successful authentication
  if (response.data?.data?.token) {
    localStorageUtil.remove("consentId");
  }
  
  return response.data;
});

//NOTE: User Email Verification
export const checkEmailExists = createAsyncThunk(
  "auth/verify/email",
  async (data) => {
    const response = await api.post("auth/existing-email", data);
    return response.data;
  },
);

// NOTE: Tasker Signup
export const taskerSignup = createAsyncThunk(
  "auth/signup/tasker",
  async (data) => {
    const response = await api.post("user/signup/tasker", data);
    return response.data;
  },
);

// NOTE: Authenticated link for resetting password
export const resetPassword = createAsyncThunk(
  "auth/reset/password",
  async (data) => {
    const response = await api.post("auth/forgot-password", data);
    return response.data;
  },
);

// NOTE: Validating the generated authenticaion token for password reset
export const validateToken = createAsyncThunk(
  "auth/validate/token",
  async ({ id, token }) => {
    const response = await api.get(`auth/verify-forgot/${id}/${token}`);
    return response.data;
  },
);

// NOTE: Resetting the password
export const updatePassword = createAsyncThunk(
  "auth/update/password",
  async ({ id, token, data }) => {
    const response = await api.post(
      `auth/change-password/${id}/${token}`,
      data,
    );
    return response.data;
  },
);

// SECTION: USER THUNKS

// NOTE: Edit Client Profile
export const updateUserProfile = createAsyncThunk(
  "auth/update/user/profile",
  async (data) => {
    const response = await api.put("users/updateProfile", data);
    return response.data;
  },
);

export const getSignedUrl = createAsyncThunk(
  "auth/signature",
  async ({ path }) => {
    const response = await api.get(`signature?path=${path}`);
    return response.data;
  },
);

// NOTE: Signout — Calls backend to set isActive:false before clearing local state
export const signoutUser = createAsyncThunk("auth/signout", async () => {
  try {
    await api.post("auth/signout");
  } catch (err) {
    // Even if the API call fails, still allow local logout
    console.warn("[Signout] Backend signout failed:", err?.message);
  }
});
